export { default } from './Tabs';
export * from './tabsClasses';
export { default as tabsClasses } from './tabsClasses';
export * from './TabsProps';
